import "react-app-polyfill/stable";

import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import { store } from "~/redux";
import "whatwg-fetch";
import "abortcontroller-polyfill/dist/abortcontroller-polyfill-only";

import "./index.scss";
import "./firebase";

import App from "./App";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
